// src/components/Dashboard/DashboardList.tsx
import React, { useState } from 'react';
import { Dashboard } from '../../../types/dashboard';
import StbButton from '../../security-toolbox-ui/StbButton';
import StbApiModal from '../../security-toolbox-ui/StbApiModal';
import { useUserRegistry } from '../../../hooks/useUserRegistry';


interface DashboardListProps {
  dashboards: Record<string, Dashboard>;
  selectedId: string | null;
  onSelectListItem: (dashboardId: string) => void;
}

const DashboardList: React.FC<DashboardListProps> = ({
  dashboards,
  selectedId,
  onSelectListItem,
}) => {
  const { 
    updateUserDashboard
  } = useUserRegistry();
    
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState<boolean>(false);
  const [deleteDashboardId, setDeleteDashboardId] = useState<string>('');

  const handleDeleteConfirm = async () => {
    if (!deleteDashboardId) return;
    const { [deleteDashboardId]: _, ...updatedDashboards } = dashboards;
    await updateUserDashboard(updatedDashboards);
    onSelectListItem(Object.keys(dashboards)[0]);
  };

  const handleDeleteClick = (dashboardId: string) => {
    setConfirmModalOpen(true);
    setDeleteDashboardId(dashboardId || '');
  };
  
  return (
    <>
      <ul style={{ listStyleType: 'none', padding: 0, marginTop: 8 }}>
        {Object.keys(dashboards).map((dashboardId) => {

          return (
            <li
              key={dashboardId}
              style={{
                padding: '10px',
                cursor: 'pointer',
                borderBottom: `${selectedId === dashboardId ? '2px' : '1px'} solid ${selectedId === dashboardId ? 'var(--hbr-color-interact-vivid-border)' : 'var(--hbr-color-gray-90)'}`,
                backgroundColor: selectedId === dashboardId
                  ? 'var(--hbr-color-neutral-bg)'
                  : hoveredId === dashboardId ? 'var(--hbr-color-interact-bg-weak-hover)' : 'transparent',
                fontWeight: selectedId === dashboardId? 'bold' : 'normal',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={() => setHoveredId(dashboardId)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={() => onSelectListItem(dashboardId)}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: selectedId === dashboardId ? 'var(--hbr-color-interact-text)' : 'var(--hbr-color-gray-10)' }}>{dashboards[dashboardId].name}</span>
                <span
                  style={{
                    display: 'flex',
                    gap: '4px',
                    minWidth: '56px',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                >
                  <span
                    style={{
                      opacity: hoveredId === dashboardId ? 1 : 0.5,
                      transition: 'opacity 0.2s',
                      pointerEvents: hoveredId === dashboardId ? 'auto' : 'none',
                      display: 'flex',
                      gap: '4px',
                    }}
                  >
                    {Object.keys(dashboards).length > 1 &&
                      <StbButton
                        role="delete"
                        variant="text"
                        iconOnly
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(dashboardId);
                        }}
                      />
                    }
                  </span>
                </span>
              </div>
            </li>
          );
        })}
      </ul>

      {/* Confirmation Modal */}
      <StbApiModal
        title="Delete Dashboard"
        open={confirmModalOpen}
        role="delete"
        onClose={async () => {
          setDeleteDashboardId('');
          setConfirmModalOpen(false);
        }}
        onSubmit={handleDeleteConfirm}
        submitLabel="Delete Dashboard"
        submitSuccess="Dashboard deleted successfully"
        submitError="Dashboard delete failed. Please try again."
      >
        Are you sure you want to delete this dashboard?
      </StbApiModal>
    </>
  );
};

export default DashboardList;